import { Pipe, PipeTransform } from '@angular/core';
import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber';

@Pipe({
    name: 'formatPhoneNumbers',
    standalone: false
})
export class FormatPhoneNumbersPipe implements PipeTransform {
   transform(phoneNumber: string): string {
      return formatPhoneNumbers(phoneNumber);
   }
}

export function formatPhoneNumbers(phoneNumber: string): string {
   if (!phoneNumber || phoneNumber.trim().length === 0) {
      return '';
   }

   const hasOnlyPhoneNumberDigitsAndCharacters = /^[\s()+\-.\d+]+$/.test(phoneNumber.trim());
   if (!hasOnlyPhoneNumberDigitsAndCharacters) {
      return phoneNumber;
   }

   const digitsOnly = phoneNumber.replace(/\D/g, '');
   const phoneUtil: PhoneNumberUtil = PhoneNumberUtil.getInstance();
   let intlDigits = digitsOnly;
   // PhoneNumberUtil requires the phone number to not have 011 and start with a + to automatically format based on country code
   if (intlDigits.startsWith('011')) {
      intlDigits = digitsOnly.substring(3);
   }
   try {
      if (digitsOnly.length > 11) {
         const intlNumber = phoneUtil.parse('+' + intlDigits);
         return phoneUtil.formatOutOfCountryCallingNumber(intlNumber, PhoneNumberFormat.US);
      } else if (digitsOnly.length >= 10) {
         const nationalNumber = phoneUtil.parseAndKeepRawInput(digitsOnly, 'US');
         return digitsOnly.length === 10
            ? phoneUtil.format(nationalNumber, PhoneNumberFormat.NATIONAL)
            : phoneUtil.formatOutOfCountryCallingNumber(nationalNumber, 'US');
      } else {
         return phoneNumber;
      }
   } catch (error) {
      return phoneNumber;
   }
}

export function formatPhoneNumbersSeconds(seconds: number): string {
   const hours = Math.floor(seconds / 3600);
   const minutes = Math.floor((seconds % 3600) / 60);
   const remainingSeconds = seconds % 60;

   return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(
      2,
      '0'
   )}`;
}
